import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { Icon } from '../Icon/index';
import { sizes } from './constants';
const borderWidth = styleUtils.rem(1);
const borderedBoxStyles = css `
  ${styleUtils.flexCenter}
  background-color: ${theme.colors.gray100};
  border-color: ${theme.colors.gray400};
  border-bottom-width: ${borderWidth};
  border-left-width: 0;
  border-right-width: ${borderWidth};
  border-top-width: ${borderWidth};
  border-style: solid;
  user-select: none;
  overflow: hidden;
`;
const sizeStyles = {
    [sizes.medium]: {
        spacing: theme.spacing.x12,
        typeStyles: theme.typeStyles.bodyLargeStyles,
    },
    [sizes.small]: {
        spacing: theme.spacing.x8,
        typeStyles: theme.typeStyles.bodyMediumStyles,
    },
};
const defaultProps = {
    size: sizes.medium,
};
const NumericStepper = ({ maxValue, minValue, onMinusClick, onPlusClick, size = defaultProps.size, value, }) => {
    const iconStyles = useMemo(() => (css `
        ${sizeStyles[size].typeStyles}
        height: ${sizeStyles[size].spacing};
        width: ${sizeStyles[size].spacing};
        padding: 0;
        ${borderedBoxStyles}

        &:first-child {
          border-left-width: ${borderWidth};
        }

        &:disabled {
          color: ${theme.colors.gray400};
        }

        &:active {
          background-color: ${theme.colors.gray300};
        }

        &:focus,
        &:hover {
          outline: none;
          cursor: pointer;
        }

        &:focus,
        &:active,
        &:hover:enabled {
          background-color: ${theme.colors.gray300};
          cursor: pointer;
        }
      `), [
        size,
    ]);
    const valueStyles = useMemo(() => (css `
        ${sizeStyles[size].typeStyles}
        ${theme.typeStyles.bodyBoldStyles}
        height: ${sizeStyles[size].spacing};
        width: ${sizeStyles[size].spacing};
        ${borderedBoxStyles}
      `), [
        size,
    ]);
    const isDecrementButtonDisabled = useMemo(() => (minValue !== undefined && value <= minValue), [
        minValue,
        value,
    ]);
    const isIncrementButtonDisabled = useMemo(() => (maxValue !== undefined && value >= maxValue), [
        maxValue,
        value,
    ]);
    const containerStyles = css `
    ${styleUtils.borderBox}
    display: flex;
  `;
    return (_jsxs("div", Object.assign({ css: containerStyles }, { children: [_jsx("button", Object.assign({ css: iconStyles, disabled: isDecrementButtonDisabled, onClick: onMinusClick, type: "button" }, { children: _jsx(Icon, { size: "small", type: "subtract" }) })), _jsx("div", Object.assign({ css: valueStyles }, { children: value })), _jsx("button", Object.assign({ css: iconStyles, disabled: isIncrementButtonDisabled, onClick: onPlusClick, type: "button" }, { children: _jsx(Icon, { size: "small", type: "add" }) }))] })));
};
const MemoizedNumericStepper = memo(NumericStepper);
export { MemoizedNumericStepper as NumericStepper };
// MC-1068 Temporary hack for Storybook.
export default NumericStepper;
